import React from 'react';
import ExampleObituaries from './ExampleObituaries';

const Landing = ({ onGetStarted }) => {
  const features = [
    {
      icon: 'bi-file-text',
      title: 'Professional Formatting',
      description: 'Beautiful, professionally formatted obituaries that honor your loved ones with dignity and respect.'
    },
    {
      icon: 'bi-pencil-square',
      title: 'Easy to Use',
      description: 'Simple form-based interface that guides you through creating a comprehensive obituary in minutes.'
    },
    {
      icon: 'bi-printer',
      title: 'Print Ready',
      description: 'Generate print-ready obituaries perfect for newspapers, programs, and memorial services.'
    },
    {
      icon: 'bi-shield-check',
      title: 'Secure & Private',
      description: 'Your information is kept secure and private. Create obituaries with complete peace of mind.'
    },
    {
      icon: 'bi-clock-history',
      title: 'Use Anytime',
      description: 'Generate up to 5 obituaries whenever you need them. No expiration date, use at your convenience.'
    },
    {
      icon: 'bi-heart',
      title: 'Honor Their Memory',
      description: 'Create meaningful tributes that capture the essence of your loved one\'s life and legacy.'
    }
  ];

  return (
    <div className="landing-section" id="features">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">Create Beautiful Obituaries</h1>
          
          <p className="hero-subtitle">
            Honor your loved ones with professionally crafted obituaries.<br />
            Simple, respectful, and ready to use.
          </p>
          
          {/* Audio Player Section */}
          <div className="audio-player-section mt-4 mb-4">
            <div className="glass-card audio-card">
              <div className="d-flex align-items-center gap-3">
                <div className="audio-icon-wrapper">
                  <i className="bi bi-headphones"></i>
                </div>
                <div className="flex-grow-1">
                  <p className="audio-label mb-1" style={{ fontSize: '0.9rem', fontWeight: '600', color: '#1e40af', marginBottom: '0.25rem' }}>
                    <i className="bi bi-info-circle me-2"></i>
                    Listen to a 2-minute explanation of our services
                  </p>
                  <audio 
                    controls 
                    className="audio-player"
                    style={{ width: '100%', maxWidth: '500px' }}
                  >
                    <source src="/obitauthor.mp3" type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column flex-md-row gap-3 justify-content-center align-items-center">
            <button 
              className="btn btn-outline-primary btn-lg"
              onClick={() => {
                const examplesSection = document.getElementById('examples');
                if (examplesSection) {
                  examplesSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              style={{ 
                color: '#000000', 
                borderColor: '#1e40af',
                backgroundColor: 'transparent',
                minWidth: '180px'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#000000';
                e.target.style.backgroundColor = 'rgba(30, 64, 175, 0.1)';
                const icon = e.target.querySelector('i');
                if (icon) icon.style.color = '#000000';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#000000';
                e.target.style.backgroundColor = 'transparent';
                const icon = e.target.querySelector('i');
                if (icon) icon.style.color = '#000000';
              }}
            >
              <i className="bi bi-eye me-2" style={{ color: '#000000' }}></i>
              <span style={{ color: '#000000' }}>View Examples</span>
            </button>
            <button 
              className="btn btn-primary btn-lg btn-with-arrow"
              onClick={onGetStarted}
            >
              Get Started
              <i className="bi bi-chevron-right chevron-animate ms-2"></i>
            </button>
          </div>
        </div>

        <div className="row g-4 mt-5">
          {features.map((feature, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div className="glass-card feature-card">
                <div className="feature-icon">
                  <i className={`bi ${feature.icon}`}></i>
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Example Obituaries Section */}
        <ExampleObituaries />

        <div className="cta-section mt-5">
          <div className="glass-card cta-card text-center">
            <h2 className="cta-title mb-3">Ready to Create a Beautiful Obituary?</h2>
            <p className="cta-description mb-4">
              Honor your loved one with a professionally crafted obituary in minutes.
            </p>
            <button 
              className="btn btn-primary btn-lg pulsate-btn btn-with-arrow"
              onClick={onGetStarted}
            >
              Get Started
              <i className="bi bi-chevron-right chevron-animate ms-2"></i>
            </button>
          </div>
        </div>

        {/* Free Resource Banner */}
        <div className="glass-card text-center mt-5 p-4" style={{ background: 'rgba(212, 175, 55, 0.08)', border: '2px solid rgba(212, 175, 55, 0.2)' }}>
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-center">
            <div className="me-md-4 mb-3 mb-md-0" style={{ fontSize: '2.5rem' }}>📋</div>
            <div className="text-md-start text-center">
              <h3 className="mb-2" style={{ color: '#1a1a2e', fontFamily: "'Playfair Display', Georgia, serif", fontSize: '1.3rem' }}>Not ready yet? Get our free checklist!</h3>
              <p className="mb-0" style={{ color: '#4a5568' }}>Obituary Writing Checklist — everything you need to gather before writing.</p>
            </div>
            <a
              href="/free-obituary-checklist"
              className="btn lead-magnet-btn ms-md-4 mt-3 mt-md-0"
              style={{ minWidth: '180px' }}
            >
              <i className="bi bi-download me-2"></i> Free Download
            </a>
          </div>
        </div>

        {/* Poetry Quote Section */}
        <div className="poetry-section">
          <div className="row">
            <div className="col-12">
              <div className="poetry-quote">
                <p className="poetry-text">
                  Though loved ones are lost love is not;<br />
                  And death shall have no dominion.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;

